"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('honey', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M14.6129 4.84261L9.92366 9.53185C8.62876 10.8267 8.62876 12.9262 9.92366 14.2211C11.2186 15.516 13.318 15.516 14.6129 14.2211L19.3021 9.53185C20.597 8.23695 20.597 6.13751 19.3021 4.84261C18.0072 3.54772 15.9078 3.54772 14.6129 4.84261Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M24.7729 13.4397L18.5206 19.692C17.2257 20.9869 17.2257 23.0863 18.5206 24.3812C19.8155 25.6761 21.9149 25.6761 23.2098 24.3812L29.4621 18.1289C30.757 16.834 30.757 14.7346 29.4621 13.4397C28.1672 12.1448 26.0678 12.1448 24.7729 13.4397Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M28.6806 18.9104L42.4506 32.6803C43.4783 33.708 43.2617 35.5909 41.9668 36.8858C40.6719 38.1807 38.7891 38.3973 37.7614 37.3696L23.9914 23.5996",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M22.4283 6.40573L11.4868 17.3473C10.1919 18.6422 10.1919 20.7416 11.4868 22.0365C12.7817 23.3314 14.8811 23.3314 16.176 22.0365L27.1175 11.095C28.4124 9.80007 28.4124 7.70063 27.1175 6.40573C25.8227 5.11084 23.7232 5.11083 22.4283 6.40573Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M13.8544 23.1421C15.278 27.5789 15.041 30.8568 13.1433 32.976C10.2968 36.1548 10.7396 44.1421 17.1704 44.1421C23.6013 44.1421 25.4903 36.1548 20.0425 33.3527",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;